<template>
  <v-card flat>
    <v-list-item>
      <v-list-item-content two-line>
        <v-list-item-title class="headline">{{
          $t('administration.mails.liste.title')
        }}</v-list-item-title>
        <v-list-item-subtitle>{{
          $t('administration.mails.liste.sub')
        }}</v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>
    <v-card-text>
      <v-simple-table>
        <thead>
          <tr>
            <th scope="col">Template de mail</th>
            <th scope="col">Description</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(m, i) in mails" :key="`template-${i}`">
            <td>
              <navigable-link
                :to="{
                  name: 'administration/mails/detail',
                  params: { id: m.type },
                }"
              >
                {{ m.libelle }}
              </navigable-link>
            </td>
            <td>{{ m.description }}</td>
          </tr>
        </tbody>
      </v-simple-table>
    </v-card-text>
  </v-card>
</template>

<script>
import Api from '@/utils/api';

export default {
  beforeRouteEnter: (to, from, next) => {
    new Api('administration/mail').get().then(response => {
      next(vm => vm.initForm(response.body));
    });
  },
  data() {
    return {
      mails: [],
    };
  },
  methods: {
    initForm(body) {
      this.mails = body;
    },
  },
};
</script>
